import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    TableContainer,
    VStack,
    Heading,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Box, useToast,Flex, Spinner,
} from "@chakra-ui/react";
import { TriangleUpIcon, TriangleDownIcon } from "@chakra-ui/icons";
import React, {useEffect, useMemo, useState} from "react";
import { useAppSelector } from "../../stateManagement/hooks";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {api, EmployeeData, PIMetadata} from "../../api/performanceAPI";
import {
    BookingDecision,
    BookingStatus,
    BookingStatusMap,
    CustomerOrStrypes,
    HeaderFilters,
    PIFilters
} from "./HeaderFiltersComponent";
import {RowComponent} from "./RowComponent"; // Import moment.js



export function PerformanceIncentiveComponent() {
  const [filterOnlyMine, setFilterOnlyMine] = useState<boolean>(true);
  const [data, setData] = useState<EmployeeData[]>([]);
  const [decisions, setDecisions] = useState<BookingStatusMap>({})
  const [metaData, setMetaData] = useState<PIMetadata>()
  const [refreshIndex, setRefreshIndex] = useState(0);
  const [loading, setLoading] = useState(false); // <-- Loader state
  const [filters, setFilters] = useState<PIFilters>({
    name: "",
    manager: "",
    project: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | null>(null);

  function toggleDateSort() {
    setSortDirection((prev) => {
      if (prev === null || prev === "desc") return "asc";
      return "desc";
    });
  }

useEffect(() => {
  const handler = setTimeout(() => setDebouncedFilters(filters), 300);
  return () => clearTimeout(handler);
}, [filters]);

  const [currentMonth, setCurrentMonth] = useState<string>(
    moment().format("MMM, YYYY")
  );

  const last12Months = Array.from({ length: 12 }, (_, idx) =>
    moment().subtract(idx, "months").format("MMM, YYYY")
  )

  const user_name = useAppSelector((state) => state.user.user.name);
  const navigate = useNavigate();
const toast = useToast();
    useEffect(() => {
        const selectedMonth = moment(currentMonth, "MMM, YYYY")
          setLoading(true); // Start loader
        api.listPerformanceIncentive(selectedMonth.year(), selectedMonth.month()+1).then(value =>{
         const incomingData = value.data?.data;
        if (Array.isArray(incomingData)) {
          setData(incomingData);
        } else {
          console.warn("Unexpected data format:", incomingData);
          setData([]); // default to empty array
        }
        console.log(value.data.metadata)
    setMetaData(value.data?.metadata);
        }
        ).catch(reason =>
        console.log("Failed to list")
        )
        .finally(() => setLoading(false)); // Stop loader
    }, [currentMonth, refreshIndex]);
  function handleFilterChange(field: keyof typeof filters, value: string) {
    setFilters((prev) => ({ ...prev, [field]: value }));
  }
  function monthCompleted(){
            if (metaData?.status === "Completed"){return true}
            return false
  }
function updateDecision(bookingId: string, status: BookingDecision) {
      if (monthCompleted()){
    toast({
      title: "Month is already completed",
      status: "warning",
      duration: 3000,
      isClosable: true,
    });
    return
      }
  setDecisions(prev => ({ ...prev, [bookingId]: status }));
}
const filteredData = useMemo(() => {
      const name = debouncedFilters.name?.toLowerCase() || "";
  const manager = debouncedFilters.manager?.toLowerCase() || "";
  const project = debouncedFilters.project?.toLowerCase() || "";
  return data.filter((row) => {
    return (
      (!name || row.FirstName.toLowerCase().includes(name)) &&
      (!manager || row.GM.toLowerCase().includes(manager)) &&
      (!project || row.Project.toLowerCase().includes(project))
    );
  });
}, [data, debouncedFilters, currentMonth]);

  const sortedData = useMemo(() => {
    if (!sortDirection) return filteredData;
    return [...filteredData].sort((a, b) => {
      const dateA = new Date(a.WorkDate).getTime();
      const dateB = new Date(b.WorkDate).getTime();
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
    });
  }, [filteredData, sortDirection]);

    function bulkUpdate(status: BookingStatus, clearAll = false, report = false) {
        if (report && metaData) {
            setLoading(true)
            api.approvePerformanceIncentive(metaData?.year, metaData?.month, convertBookingStatusMapToApproveList(decisions))
                .then(value => {
                    setRefreshIndex(prevState => prevState + 1)
                    setDecisions({})
                    toast({
                        title: "Review completed successfully!",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    })

                })
                .catch(reason => console.log(reason))
                .finally(() =>
                    setLoading(false)
                )

            return
        }
        if (clearAll) {
            setDecisions({})
            return
        }
        const newDecisions: BookingStatusMap = decisions;
        filteredData.forEach(row => {
            if (row.BookingID in newDecisions) {
                // BookingID exists - update status

                newDecisions[row.BookingID] = {status: status, requested: newDecisions[row.BookingID].requested};
            } else {
                // BookingID doesn't exist - insert new
                newDecisions[row.BookingID] = {status: status, requested: "Strypes Requested"};
            }
        });
        setDecisions(prev => ({...prev, ...newDecisions}));
    }
function bulkMark (requested: CustomerOrStrypes)
{
      const newDecisions: BookingStatusMap = decisions;
  filteredData.forEach(row => {
  if (row.BookingID in newDecisions) {
    // BookingID exists - update status
    newDecisions[row.BookingID] =  {status: newDecisions[row.BookingID].status,requested :  requested};

  } else {
    // BookingID doesn't exist - insert new
    newDecisions[row.BookingID] = { requested: requested};
  }
  });
  setDecisions(prev => ({ ...prev, ...newDecisions }));
}
function convertBookingStatusMapToApproveList(statusMap: BookingStatusMap): BookingStatusMap {
  // Example
//     "719261": {
//         "requested": "Strypes Requested",
//         "status": "approve"
//     },
//     "720413": {
//         "requested": "Strypes Requested",
//         "status": "reject"
//     },
//     "721945": {
//         "requested": "Customer Requested",
//         "status": "approve"
//     },
//     "721957": {
//         "requested": "Customer Requested"
//     }
  return statusMap;
}
// {
//     "718410": {
//         "requested": "Customer Requested"
//     },
//     "719261": {
//         "requested": "Customer Requested"
//     },
  return (
    <>
      <VStack width="100%" spacing={4} flexGrow={1} >
          <Box width="100%" textAlign="center">
            <Heading>Performance Incentive</Heading>
          </Box>

        <Box width="100%" px={3}>
            <HeaderFilters filters={filters} handleFilterChange={handleFilterChange}
                           data={filteredData} bulkUpdate={bulkUpdate} bulkMark={bulkMark} monthCompleted={monthCompleted()}
                           metadata={metaData}/>
        </Box>
        <Box width="100%" px={3}> {/* px adds horizontal padding */}
        <Tabs width={"95%"} justifyContent={"flex-start"} >
          <TabList justifyContent={"flex-start"}>
            {last12Months.map((month) => (
              <Tab key={month} onClick={() => setCurrentMonth(month)}>
                {month}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {last12Months.map((month) => (
              <TabPanel key={month}>
                <TableContainer overflowX={"visible"} overflowY={"visible"}>
                  <Table variant="simple" >
                    <Thead>
                      <Tr>
                        <Th>Name</Th>

                        <Th
                          onClick={toggleDateSort}
                          cursor="pointer"
                          userSelect="none"
                          _hover={{ color: "blue.500" }}
                        >
                          Date{" "}
                          {sortDirection === "asc" ? (
                            <TriangleUpIcon boxSize={3} />
                          ) : sortDirection === "desc" ? (
                            <TriangleDownIcon boxSize={3} />
                          ) : null}
                        </Th>
                        <Th>Hours</Th>
                        <Th>Incentive</Th>
                          <Th>Requested By</Th>
                        <Th>Project</Th>
                        <Th>Manager</Th>
                        <Th>Department</Th>

                          <Th>Actions</Th>
                          <Th>Approved</Th>
                          <Th>ID</Th>
                          <Th>Is Internal</Th>
                      </Tr>
                    </Thead>
                    <Tbody>

                        {loading &&<Flex
    position="fixed"
    top={0}
    left={0}
    width="100vw"
    height="100vh"
    bg="rgba(255, 255, 255, 0.7)"
    align="center"
    justify="center"
    zIndex={9999}
  >
    <Spinner size="xl" color="blue.500" />
  </Flex>
}

  {sortedData.map((row) => (
    <RowComponent
      key={row.BookingID}
      row={row}
      decision={decisions[row.BookingID]}
      onDecisionChange={updateDecision}
    />
  ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
        </Box>
      </VStack>
    </>
  );
}
